import { Drawer, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import { theme } from '../../../../components/theme/theme';
import CustomModal from '../../../../components/CustomModal';
import { ArrowBackIcon, CancelLinkingIcon } from '../../../../components/icons';
import Button from '../../../../components/button/Button';
import { useNavigate } from 'react-router-dom';

const CloseConfirmation = ({
    open,
    onClose
}: {
    open: boolean;
    onClose: () => void;
}) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [finalClose, setFinalClose] = useState(false);
    const navigate = useNavigate();
    
    return (
        <>
            {isMobile ? (
                <Drawer
                    anchor={'bottom'}
                    open={open}
                    onClose={() => {
                        onClose();
                        setFinalClose(false);
                     }}
                    sx={{
                        '.MuiDrawer-paperAnchorRight': {
                            width: {
                                xs: '95%',
                                lg: '33rem'
                            }
                        }
                    }}
                >
                    <div className='h-[423px] flex flex-col justify-center items-center'>
                        <CancelLinkingIcon
                            color={finalClose ? '#B42318' : undefined}
                        />
                        <p className='text-ebony text-[20px] leading-[30px] mt-[40px] mb-4  max-w-[238px] text-center'>
                            {finalClose
                                ? 'Registration cancelled'
                                : 'Cancel registration?'}
                        </p>
                        <p className='text-gray200 text-[14px] leading-[20px] mb-[24px] max-w-[296px] text-center'>
                            {finalClose
                                ? 'Your registration process is cancelled successfully.'
                                : 'You’ll lose any progress made. You can restart the process from the dashboard.'}
                        </p>

                        {finalClose ? (
                            <Button
                                text='Return to dashboard'
                                leftIcon={<ArrowBackIcon color='white' />}
                                className='w-full max-w-[350px]'
                                onClick={() => {
                                    navigate('/investment');
                                    onClose();
                                }}
                            />
                        ) : (
                            <div className='flex w-full max-w-[350px] mt-4 gap-4'>
                                <Button
                                    text='No'
                                    variant='secondaryOutline'
                                    className='flex-1'
                                    onClick={() => {
                                        onClose();
                                        setFinalClose(false);
                                     }}
                                />
                                <Button
                                    text='Yes'
                                    className='flex-1'
                                    onClick={() => {
                                        setFinalClose(true);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </Drawer>
            ) : (
                <CustomModal
                    maxWidth='470px'
                    open={open}
                    onClose={() => {
                       onClose();
                       setFinalClose(false);
                    }}
                    title=''
                >
                    <div className='h-[423px] flex flex-col justify-center items-center'>
                        <CancelLinkingIcon
                            color={finalClose ? '#B42318' : undefined}
                        />
                        <p className='text-ebony text-[20px] leading-[30px] mt-[40px] mb-4  max-w-[238px] text-center'>
                            {finalClose
                                ? 'Registration cancelled'
                                : 'Cancel registration?'}
                        </p>
                        <p className='text-gray200 text-[14px] leading-[20px] mb-[24px] max-w-[296px] text-center'>
                            {finalClose
                                ? 'Your registration process is cancelled successfully.'
                                : 'You’ll lose any progress made. You can restart the process from the dashboard.'}
                        </p>

                        {finalClose ? (
                            <Button
                                text='Return to dashboard'
                                leftIcon={<ArrowBackIcon color='white' />}
                                className='w-full max-w-[350px]'
                                onClick={() => {
                                    navigate('/investment');
                                    onClose();
                                }}
                            />
                        ) : (
                            <div className='flex w-full max-w-[350px] mt-4 gap-4'>
                                <Button
                                    text='No'
                                    variant='secondaryOutline'
                                    className='flex-1'
                                    onClick={() => {
                                        onClose();
                                        setFinalClose(false);
                                     }}
                                />
                                <Button
                                    text='Yes'
                                    className='flex-1'
                                    onClick={() => {
                                        setFinalClose(true);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </CustomModal>
            )}
        </>
    );
};

export default CloseConfirmation;
